import { useState } from 'react';
import { Button } from 'react-bootstrap';
import { SearchModal } from '../header_icons/header_icons';

const MobileSearch = () => {
  const [searchOpen, setSearchOpen] = useState(false);

  return (
    <>
      <Button
        variant="link"
        className="py-1 px-0 text-left fw-normal"
        onClick={() => setSearchOpen(true)}
      >
        <i className="far fa-search fa-fw icon__before-text" />
        Search
      </Button>
      <SearchModal
        show={searchOpen}
        onHide={() => setSearchOpen(false)}
        isMobile
      />
    </>
  );
};

export default MobileSearch;
